import { InputLabel } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Search, X } from "react-feather"
import { components } from "react-select"
import AsyncSelect from "react-select/async"
import { SECONDARY_COLOR } from "../../theme"

const AutoComplete = (props) => {
	const [erro, setErro] = useState(false)
	const [focus, setFocus] = useState(false)

	const onblur = () => {
		props.onBlur && props.onBlur()
		if (props.obrigatorio && !(props.value || props.inputValue)) {
			setErro(true)
		} else {
			setErro(false)
		}
		setFocus(false)
	}

	useEffect(() => {
		if (props.obrigatorio && (props.value || props.inputValue)) {
			setErro(false)
		}
	}, [props.obrigatorio, props.value, props.inputValue])

	const onFocus = () => {
		setFocus(true)
		setErro(false)
	}

	const classes = useStyles()

	const placeHolderTratado = props.obrigatorio ? `${props.placeholder} *` : props.placeholder
	const opcao = (propriedades) => {
		return (
			<div className={classes.divOption}>
				<components.Option {...propriedades} />
				{props.addonOption && props.addonOption(propriedades.data, propriedades.isFocused)}
			</div>
		)
	}

	const DropdownIndicator = (propriedades) => {
		if (propriedades.hasValue) return null

		return (
			<components.DropdownIndicator {...propriedades}>
				<Search color={propriedades.isFocused ? SECONDARY_COLOR : "hsl(0,0%,80%)"} />
			</components.DropdownIndicator>
		)
	}

	const ClearIndicator = (propriedades) => {
		return (
			<components.ClearIndicator {...propriedades} className={classes.iconeLimpar}>
				<X size={15} color={propriedades.isFocused ? SECONDARY_COLOR : "#82888a"} />
			</components.ClearIndicator>
		)
	}

	return (
		<div style={{ position: "relative" }}>
			{(focus || props.value || props.inputValue) && (
				<InputLabel
					style={{
						color: erro || props.campoInvalido ? "#f44336" : focus ? SECONDARY_COLOR : "rgba(0, 0, 0, 0.54)",
					}}
					className={classes.labelFlutuante}
					htmlFor="outlined-age-native-simple"
				>
					{placeHolderTratado}
				</InputLabel>
			)}
			<AsyncSelect
				menuPortalTarget={document.body}
				id={props.id}
				autoFocus={props.autoFocus}
				placeholder={placeHolderTratado}
				noOptionsMessage={props.naoEncontradoMensagem}
				loadingMessage={props.carregandoMensagem}
				openMenuOnClick={false}
				closeMenuOnSelect={true}
				blurInputOnSelect={false}
				menuPlacement={props.aberturaOpcoes}
				defaultOptions={props.defaultOptions}
				isClearable={props.limpavel}
				loadOptions={props.loadOptions}
				getOptionValue={props.getOptionValue}
				getOptionLabel={props.getOptionLabel}
				styles={estilos(erro, props.campoInvalido)}
				onChange={props.onChange}
				theme={props.tema}
				value={props.value}
				components={{ Option: opcao, DropdownIndicator, ClearIndicator }}
				tabSelectsValue={false}
				onInputChange={props.onInputChange}
				onBlur={onblur}
				inputValue={props.inputValue}
				cacheOptions={props.cacheOpcoes}
				onFocus={onFocus}
				isDisabled={props.desativarCampo}
			/>
		</div>
	)
}

const corPlaceholder = (erro, isFocused) => {
	if (erro && !isFocused) return "#f44336"

	if (isFocused) return "rgba(0, 0, 0, 0)"

	return "rgba(0, 0, 0, 0.54)"
}

const estilos = (erro, campoInvalido) => ({
	menu: (styles) => ({
		...styles,
		zIndex: 1300,
		maxHeight: "200px",
	}),
	menuList: (styles) => ({
		...styles,
		maxHeight: "200px",
		"&::-webkit-scrollbar": {
			width: "8px",
			height: "8px",
			cursor: "pointer",
		},
		"&::-webkit-scrollbar-track": {
			background: "#f1f1f1",
		},
		"&::-webkit-scrollbar-thumb": {
			background: "rgba(0, 0, 0, 0.2)",
			borderRadius: "10px",
		},
	}),
	menuPortal: (styles) => ({
		...styles,
		zIndex: 1300,
	}),
	indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
	input: (provided) => ({
		...provided,
		paddingTop: "12px",
		paddingBottom: "12px",
		width: "100%",
		fontFamily: "CircularStd-Book",
		fontSize: "16px",
		input: {
			opacity: "1 !important",
		},
		cursor: "text",
	}),
	control: (styles, { isFocused }) => {
		const campoComErro = campoInvalido || (erro && !isFocused)
		return {
			...styles,
			":hover": {
				borderColor: campoComErro ? "#f44336" : isFocused ? SECONDARY_COLOR : "black",
			},
			backgroundColor: "transparent",
			boxShadow: isFocused && !campoInvalido ? `0 0 0 1px ${SECONDARY_COLOR}` : "none",
			borderColor: campoComErro ? "#f44336" : isFocused ? SECONDARY_COLOR : "hsl(0, 0%, 70%)",
			paddingRight: "8px",
			paddingLeft: "8px",
		}
	},
	placeholder: (styles, { isFocused }) => ({
		...styles,
		fontFamily: "CircularStd-Book",
		fontSize: "1rem",
		color: corPlaceholder(erro, isFocused),
	}),
	option: (styles, { isDisabled, isFocused, isSelected }) => {
		return {
			...styles,
			backgroundColor: null,
			cursor: "pointer",
			color: "#61688B",
			":active": {
				...styles[":active"],
				backgroundColor: "transparent",
			},
		}
	},
})

const useStyles = makeStyles({
	iconeLimpar: {
		paddingRight: "15px !important",
		cursor: "pointer",
	},
	labelFlutuante: {
		color: "rgba(0, 0, 0, 0.54)",
		padding: "0 8px 0 8px",
		zIndex: "1300",
		position: "absolute",
		fontSize: "1rem",
		transform: "scale(0.75) translate(8px, -8px)",
		lineHeight: "1",
		backgroundColor: "#FFFFFF",
	},
	divOption: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
	},
	helperText: {
		margin: "8px 12px 0",
	},
})

AutoComplete.propTypes = {
	id: PropTypes.string,
	autoFocus: PropTypes.bool,
	placeholder: PropTypes.string,
	naoEncontradoMensagem: PropTypes.func,
	carregandoMensagem: PropTypes.func,
	aberturaOpcoes: PropTypes.string,
	defaultOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
	limpavel: PropTypes.bool,
	loadOptions: PropTypes.func,
	getOptionValue: PropTypes.func,
	getOptionLabel: PropTypes.func,
	onChange: PropTypes.func,
	theme: PropTypes.object,
	components: PropTypes.object,
	onInputChange: PropTypes.func,
	onBlur: PropTypes.func,
	inputValue: PropTypes.string,
	addonOption: PropTypes.func,
	desativarCampo: PropTypes.bool,
}

AutoComplete.defaultProps = {
	id: "",
	autoFocus: false,
	naoEncontradoMensagem: () => "Não foram encontrados registros",
	carregandoMensagem: () => "Carregando...",
	aberturaOpcoes: "auto",
	limpavel: false,
	FormHelperTextProps: { error: true },
	helperText: false,
	desativarCampo: false,
}

export default AutoComplete
